export default __webpack_public_path__ + "static/media/browser-width.a038e575.svg";